<template>
  <div class="media-displayer">
    <!-- Display single gallery when no sub-galleries -->
    <MediaDisplayerSingleGallery
      v-if="!gallery.sub_gallery || gallery.sub_gallery.length === 0"
      :gallery="gallery"
      @openGallery="$emit('openGallery', $event)"
    />

    <!-- Display sub-galleries based on sub_gallery_display mode -->
    <MediaDisplayerTabs
      v-else-if="gallery.sub_gallery_display === SubGalleryDisplayType.TAB.value"
      :gallery="gallery"
      @openGallery="$emit('openGallery', $event)"
    />

    <MediaDisplayerList
      v-else
      :gallery="gallery"
      @openGallery="$emit('openGallery', $event)"
    />
  </div>
</template>

<script>
import MediaDisplayerSingleGallery from './subGalleryDisplay/MediaDisplayerSingleGallery'
import MediaDisplayerTabs from './subGalleryDisplay/MediaDisplayerTabs'
import MediaDisplayerList from './subGalleryDisplay/MediaDisplayerList'
import { SubGalleryDisplayType } from './constants/subGalleryDisplayType'

export default {
  name: 'MediaDisplayer',

  components: {
    MediaDisplayerSingleGallery,
    MediaDisplayerTabs,
    MediaDisplayerList
  },

  data() {
    return {
      SubGalleryDisplayType
    }
  },

  props: {
    gallery: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.media-displayer {
  margin-bottom: 2rem;
}
</style>
